var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27727 3.95788L9.27683 3.95837L8.73817 4.54742L8.0002 5.35442L7.26223 4.54742L6.72357 3.95837L6.72246 3.95715C5.67109 2.80362 4.06747 2.69268 3.03036 3.63029C1.7334 4.80529 1.65502 6.96146 2.82765 8.24795L7.99883 13.9144L13.1704 8.24751L13.1706 8.2473C14.3453 6.96086 14.2669 4.80503 12.9699 3.63013L9.27727 3.95788ZM9.27727 3.95788C10.3319 2.80311 11.9331 2.69306 12.9698 3.63006L9.27727 3.95788Z",
    stroke: "#6158D4",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartPurple);
export default __webpack_public_path__ + "static/media/heart_purple.a1887c714d976df79d0c4c03a459b7b6.svg";
export { ForwardRef as ReactComponent };